import React, { useEffect } from "react";
import { DatePicker, DatePickerInput, Button, Stack, Select, SelectItem, Tabs, Tab, TabList, TabPanels, TabPanel } from "@carbon/react";
import { CardComponent } from '../../../components/Layouts/Card.styles'
import Card from '../../../components/Layouts/Card';
import { Calendar } from "@carbon/icons-react";
import Typography from "../../../components/Basics/Typography";
import { g90, g100 } from '@carbon/themes';
import { useDispatch, useSelector } from 'react-redux'
import { useDatePicker, useSelect } from "../../../components/Inputs/Inputs.hooks";
import { checkErrorRequired } from "../../../modules/errors/validations";
import LoadingContent from "../../../components/Animations/LoadingContent";
import { onGetScheduledVolvoThunk } from "./Scheduled.actions";
import InformationContainer from "../../../components/Basics/Information.container";
import EscheduledTable from "./ScheduledTable.container";

const ScheduledContainer = () => {
  const dispatch = useDispatch()
  const { error, loading, data } = useSelector(state => state.scheduled)

  useEffect(() => {
    if (!loading) {
      return
    }
    dispatch(onGetScheduledVolvoThunk())
  }, [])
  return (
    <>
      <Stack gap={3}>
        <CardComponent width="100%">
          <Card justifyContent='flex-start'>
            <Calendar size={18} />
            <Typography className='cds--type-heading-compact-01'>
              TABLA DE EQUIPOS Y TIEMPO RESTANTE PARA MANTENIMIENTO PROGRAMADO - TABLA DE DATOS
            </Typography>
          </Card>
          <InformationContainer description='Esta característica todavía se encuentra en desarrollo y podría no estar funcionando.' />
          
          {loading && !error && (
            <LoadingContent />
          )}
          {!loading && error && (
            <>
              <CardComponent width="10%">
                <Typography className='cds--type-heading-compact-01'>
                  No hay datos para este dia
                </Typography>
              </CardComponent>
            </>
          )}
          {!loading && !error && (
            <Card>
              <Card background={g100.background} width='100%' flexDirection='column' alignItems='left' gap='20px'>
                <EscheduledTable />
              </Card>
            </Card>
          )}
        </CardComponent>
      </Stack>
    </>
  )
};

export default ScheduledContainer;